import React from 'react';
import styled from 'styled-components';
import { FaLinkedin, FaThumbsUp, FaComment } from 'react-icons/fa';

const Card = styled.div`
    width: 100%;
    background: ${({ theme }) => theme.card};
    border: 0.1px solid #854CE6;
    box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
    border-radius: 16px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    
    &:hover {
        transform: translateY(-8px);
        box-shadow: rgba(23, 92, 230, 0.3) 0px 8px 32px;
        border: 0.1px solid #854CE6;
    }

    @media (max-width: 768px) {
        padding: 16px;
    }
`;

const Image = styled.img`
    width: 100%;
    height: 280px;
    object-fit: cover;
    border-radius: 12px;
    background: ${({ theme }) => theme.card_light};
    
    @media (max-width: 768px) {
        height: 240px;
    }
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.text_primary};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
`;

const Description = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
`;

const Details = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: auto;
`;

const Engagement = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 13px;
    color: ${({ theme }) => theme.text_secondary};
`;

const EngagementItem = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

const Date = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.text_secondary + 95};
`;

const ViewButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px 20px;
    background: linear-gradient(225deg, hsla(271, 100%, 50%, 1) 0%, hsla(294, 100%, 50%, 1) 100%);
    color: white;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    margin-top: 8px;
    border-radius: 8px;
    
    &:hover {
        transform: scale(1.02);
        box-shadow: rgba(133, 76, 230, 0.4) 0px 4px 16px;
    }
`;

const CardWrapper = styled.div`
    position: relative;
`;

const FeaturedCard = ({ post }) => {
    return (
        <CardWrapper>
            <Card onClick={() => window.open(post.link, '_blank')}>
                {post.image && <Image src={post.image} alt={post.title} />}
                <Title>{post.title}</Title>
                <Description>{post.description}</Description>
                <Details>
                    <Engagement>
                        <EngagementItem>
                            <FaThumbsUp size={14} />
                            {post.likes}
                        </EngagementItem>
                        <EngagementItem>
                            <FaComment size={14} />
                            {post.comments}
                        </EngagementItem>
                    </Engagement>
                    <Date>{post.date}</Date>
                </Details>
                <ViewButton
                    href={post.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                >
                    <FaLinkedin size={18} />
                    View Full Post on LinkedIn
                </ViewButton>
            </Card>
        </CardWrapper>
    );
};

export default FeaturedCard;
